import {Button, Modal} from "@mantine/core";
import React, {useState} from "react";
import 'react-cron-generator/dist/cron-builder.css'
import "./../css/cronUiModal.css"
import {KpiProps} from "../types/types";

export type CronModalPros = {
    opened: boolean,
    setOpened: (flag: boolean) => void
}

const CronUIModal = (props: KpiProps & CronModalPros) => {
    const [validationState, setValidationState] = useState('');
    const [state, setState] = useState(props.kpiInfo.cron || "");


    const setCronValue = () => {
        // if we select cron then we don't need to set the aggregation names
        props.setKpiInfo({...props.kpiInfo, cron: state})
        props.setOpened(false);
    }

    const handleFreqInput = (event: any) => {
        const inputVal = event.target.value;
        setState(inputVal);
        setValidationState("");
    }

    const cronInputValidation = (userCron: any) => {
        const reg = new RegExp(/^(\*|([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])|\*\/([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])) (\*|([0-9]|1[0-9]|2[0-3])|\*\/([0-9]|1[0-9]|2[0-3])) (\*|([1-9]|1[0-9]|2[0-9]|3[0-1])|\*\/([1-9]|1[0-9]|2[0-9]|3[0-1])) (\*|([1-9]|1[0-2])|\*\/([1-9]|1[0-2])) (\*|([0-6])|\*\/([0-6]))$/);
        return reg.test(userCron);
    }

    const handleValidateClick = () => {
        if (cronInputValidation(state)) {
            setCronValue();
        } else {
            setValidationState('The given cron Expression is Wrong !!');
        }
    }

    return <div>
        <Modal
            className="aggregationModal__container"
            opened={props.opened}
            onClose={() => props.setOpened(false)}
            radius="lg"
            size="1000px"
        >

            <div className="step2__container wizard-content-card" style={{
                marginLeft: "10%",
                marginTop: "13%",
                paddingTop: "8%",
                paddingBottom: "8%"
            }}>
                <input id="freqInput" type="text" placeholder="Enter your cron expression" className="form-control"
                       value={state} onChange={handleFreqInput}/>
                {
                    <small style={{color: 'red'}}>{validationState}</small>
                }
                <Button color="teal" variant={"outline"} onClick={handleValidateClick}>Apply</Button>

                <div className="aggregation__container__submitButton">
                </div>
            </div>


        </Modal>

    </div>
}

export default CronUIModal;